// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"859c1cd1","287":"08f3cabb","370":"5bf22717","520":"5490bc75","524":"7e20dd14","551":"bba1d332","734":"7045c217","870":"c3d662f6","967":"dd6c31ed"}[chunkId] + ".chunk.js";
};